import {remote} from '../constants/environment';
import {IPasswordReset} from '../interfaces/dtos';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postChangePassword = async (
  payload: IPasswordReset,
  token: string,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getChangePasswordUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'PUT',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload,
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          return {
            success: true,
            payload: {},
          };
        } else {
          return {
            success: false,
            payload: {
              credentials: null,
            },
          };
        }
      }
    },
    remoteURI,
  )) as IStandardServiceResponse;
};
